import { Postdata, getData } from './GlobalApi';

const PREFIX = 'academics/activities/reconciliation';

export const submitReconciliationReport = (payload) =>
  Postdata(`${PREFIX}-report/submit/`, payload);

export const revokeReconciliationReport = (payload) =>
  Postdata(`${PREFIX}-report/revoke/`, payload);

export const listReconciliationReports = (params = {}) => {
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
  ).toString();
  return getData(`${PREFIX}-report/${qs ? `?${qs}` : ''}`);
};

export const getReconciliationStats = (activityId) =>
  getData(`${PREFIX}-report/stats/?activity_id=${activityId}`);

export const getReconciliationLedger = ({ studentId, activityId }) => {
  const qs = new URLSearchParams({ student_id: studentId });
  if (activityId) qs.set('activity_id', activityId);
  return getData(`${PREFIX}-ledger/?${qs.toString()}`);
};

// Friendly mapping from backend error messages to display text.
export const RECONCILIATION_ERROR_MESSAGES = {
  'Invalid PIN': "PIN doesn't match. Try again.",
  'Security PIN is not configured for your account':
    'Set up your security PIN in Profile first.',
  'You do not have permission to submit this report type':
    'You are not allowed to submit this report type.',
  'You do not have permission to revoke this report type':
    'You are not allowed to revoke this report type.',
  'An active report of this type already exists':
    'This report has already been submitted. Refreshing…',
  'Reason is required': 'Please enter a reason for revoking.',
  'Report is already revoked': 'This report has already been revoked.',
};

export const friendlyReconciliationError = (err) => {
  if (!err) return 'Something went wrong';
  // Eligibility / already-issued errors are returned with descriptive prose;
  // pass them through verbatim so the operator sees the precise reason.
  if (
    err.startsWith('Student has pending dues') ||
    err.startsWith('Library NOC is currently') ||
    err.startsWith('Student has no Library NOC')
  ) {
    return err;
  }
  return RECONCILIATION_ERROR_MESSAGES[err] || err;
};
